import { createSlice } from "@reduxjs/toolkit";
import { defaultPage, defaultRowsPerPage } from "../../../Utils/constants";

const initialState = {
  rowsPerPage: defaultRowsPerPage,
  pageNo: defaultPage,
};

export const paginationSlice = createSlice({
  name: "pagination",
  initialState,
  reducers: {
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    setPageNumber: (state, { payload }) => {
      state.pageNo = payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

// export actions that does not involve api calls
export const { goToPage, setPageNumber, setRowsPerPage } = paginationSlice.actions;

// export reducer
export default paginationSlice.reducer;
